import { render, staticRenderFns } from "./QuerySummary.vue?vue&type=template&id=6087275b&"
import script from "./QuerySummary.vue?vue&type=script&lang=js&"
export * from "./QuerySummary.vue?vue&type=script&lang=js&"
import style0 from "./QuerySummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports